import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { ArrowUpComponent, ArrowDownComponent } from 'ui/Icons';
import { SvgIcon } from 'ui/SvgIcon';

interface IDetailsLinkProps {
  isOpen: boolean;
  onClick: (open: boolean) => void;
  text: string;
  className?: string;
}

export const DetailsLink: React.FC<IDetailsLinkProps> = ({ isOpen, text, onClick, className }) => {
  const handleClick = useCallback(() => {
    onClick(!isOpen);
  }, [isOpen, onClick]);

  const arrowIcon = useMemo(() => (isOpen ? ArrowUpComponent : ArrowDownComponent), [isOpen]);
  const mainClassName = classNames('details-link text-brown-100 text-15px leading-20px cursor-pointer', className);

  return (
    <a className={mainClassName} onClick={handleClick}>
      <span className="details-link-text underline hover:no-decoration active:underline select-none">{text}</span>
      <SvgIcon IconComponent={arrowIcon} className="w-[11px] fill-brown-prime-80 details-link-icon relative -top-2px ml-7px inline" />
    </a>
  );
};
